import script from "./DefaultViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultViewer.vue?vue&type=script&setup=true&lang=js"

import "./DefaultViewer.vue?vue&type=style&index=0&id=43daa3c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43daa3c8"]])

export default __exports__